<div class="results-options-container">
    <mat-button-toggle-group class="more-options-selector" [value]=optionSelected().id  [ngModel]="optionSelected" (ngModelChange)="optionSelectedChange($event)" aria-label="Favorite Color">
        <ng-container *ngFor="let option of moreOptionsSelector">
            <mat-button-toggle [ngClass]="optionSelected().id === option.id ? 'toggle-active' : ''" [value]="option" [disabled]="routeFormResults()![option.id].plan.minDuration === -1" class="toggle-button">
                <div class="toggle-button-content-container">
                    <mat-icon [svgIcon]="option.id"></mat-icon>
                    <span [appShowDuration]="routeFormResults()![option.id].plan.minDuration" *ngIf="routeFormResults()![option.id].plan.minDuration !== -1"></span>
                </div>
            </mat-button-toggle>
        </ng-container>
    </mat-button-toggle-group>
    <h3>{{'routeResults.selectRouteToSeeDetails' | transloco}}:</h3>
    <ng-container [ngSwitch]="optionSelected().id">
        <ng-container *ngSwitchCase="busId">
            <div class="itinerary-tab">
                <app-route-itinerary-banners [optionPlan]="routeFormResults()!.bus.plan"> </app-route-itinerary-banners>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="walkId">
            <div class="itinerary-tab">
                <app-route-itinerary-banners [optionPlan]="routeFormResults()!.walk.plan"> </app-route-itinerary-banners>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="bicycleId">
            <div class="itinerary-tab">
                <app-route-itinerary-banners [optionPlan]="routeFormResults()!.bicycle.plan"> </app-route-itinerary-banners>
            </div>
        </ng-container>
        <ng-container *ngSwitchCase="allId">
            <div class="itinerary-tab">
                <app-route-itinerary-banners [optionPlan]="routeFormResults()!.all.plan"> </app-route-itinerary-banners>
            </div>
        </ng-container>
    </ng-container>
</div>